module.exports = __webpack_public_path__ + "static/media/OpenSans-Italic.0d14a777.ttf";